import Bowser from 'bowser';

const parseUserAgent = () => Bowser.getParser(window.navigator.userAgent);

const hasTouchSupport = (): boolean =>
  'ontouchstart' in window || window.navigator.maxTouchPoints > 0;

const isiPadDesktopMode = (): boolean =>
  parseUserAgent().satisfies({ macos: { safari: '>=13' } })
    ? hasTouchSupport()
    : false;

export const isIosDevice = (): boolean =>
  parseUserAgent().getOSName(true) === 'ios' || isiPadDesktopMode();

export const isMobileDevice = (): boolean =>
  parseUserAgent().getPlatformType(true) === 'mobile';
